<template>
    <el-form v-if="isShow" :inline="true" class="subform-field-item">
        <el-table :data="formRows1" :border="true" tooltip-effect="light" stripe style="width: 100%" :key="loadTimerField" @cell-click="subFormCellClick">
            <el-table-column
              type="index"
              width="36">
            </el-table-column>
            <el-table-column
                v-for="(column, index) in columnNames"
                :key="index"
                :prop="column.id"
                :label="column.label"
                :show-overflow-tooltip="false"
                :width="setColumnWidth(column)"
                min-width="150px"
                >
                <template slot-scope="scope">
                    <FieldItem v-if="column.isApproval" :linkFieldCache="linkFieldCache" :isPrintPage="isPrintPage" :isFromSubForm="isFromSubForm" :isApproval="column.isApproval"  :isRead="isReadOnly(column,formField[scope.$index]) || column.isRead" :field="fieldList[index]" :formData="formField[scope.$index]" :parentFormData="formData" @autoUserComplateData="autoUserComplateData" :reqSouce="1" :fieldsList="fieldsList"/>
                    <FieldItem v-else :linkFieldCache="linkFieldCache" :isPrintPage="isPrintPage" :isApproval="column.isApproval" :isFromSubForm="isFromSubForm" :isRead="isReadOnly(column,formField[scope.$index]) || ((isRead && subformIsReadTmp) || fieldList[index].isRead)" :field="fieldList[index]" :formData="formField[scope.$index]" :parentFormData="formData" @autoUserComplateData="autoUserComplateData" :reqSouce="1" :fieldsList="fieldsList"/>
                </template>
            </el-table-column>
            <el-table-column v-if="(!isRead || !subformIsReadTmp) && !synchronousApprovalCommentsState" fixed="right" label="操作" width="60px"  align="center">
                <template slot-scope="scope">
                    <el-button type="danger" v-show="!scope.row.isDefault || !subform.options.unDelDefaultValue" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDeleteItem(scope.$index, formRows1)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button v-if="(!isRead || !subformIsReadTmp) && !synchronousApprovalCommentsState" type="primary" plain @click="handleAddRow">添加</el-button>
    </el-form>
</template>

<script>
    import { isEmpty, cloneDeep } from 'lodash';
    import { getFormFieldListByIds } from '@/data-model';
    export default {
        data () {
            return {
                isFromSubForm: true,
                isShow: false,
                // columnNames: [],
                formRows: [],
                temp: [
                    {
                        '461E84DA16A46CE5': '',
                        'F189B03456DABDD0': '',
                        'F5E6B2FC1633874C': ''
                    }
                ],
                loadTimerField: '',
                linkFieldCache: new Map(),
                synchronousApprovalCommentsState: false,
                subformIsReadTmp: false
            };
        },
        props: {
            subform: {
                type: Object
            },
            formData: {
                type: Object
            },
            isRead: {
                type: Boolean,
                default: false
            },
            subformIsRead: {
                type: Boolean,
                default: false
            },
            isPrintPage: {// 是否是打印页面
                type: Boolean,
                default: false
            },
            fieldsList: {
                type: Array
            },
            approvalStatus: {
                type: Number,
                default: 0
            },
            taskInstance: {
                type: Object
            }
        },
        computed: {
            fieldList () {
                // this.subform.options.fieldList.forEach((element, index) => {
                //     element.label = element.origName ? element.origName : element.name;
                //     element.name = '';
                //     element.origName = element.label;
                // });
                for (let i = 0; i < this.subform.options.fieldList.length; i++) {
                    let element = this.subform.options.fieldList[i];
                    // let temEl = cloneDeep(element);
                    // console.log(temEl);
                    element.label = element.origName ? element.origName : element.name;
                    element.name = '';
                    element.origName = element.label;
                }
                return this.subform.options.fieldList;
            },
            columnNames () {
                // return this.subform.options.fieldList.map(element => {
                return this.fieldList.map(element => {
                    // let temEl = cloneDeep(element);
                    // console.log(temEl);
                    let label = '';
                    if (element.label) {
                        label = element.label;
                    } else {
                        label = element.origName;
                    }
                    // let isSubColumn = false;
                    let isApproval = false;
                    let isRead = false;
                    // let subColumns = [];
                    if (element.isApproval) {
                        // isSubColumn = true;
                        isApproval = true;
                        isRead = element.isRead;
                        // subColumns = element.subColumns;
                    }
                    return {
                        id: element.id,
                        name: label,
                        label: label,
                        type: element.type,
                        options: element.options,
                        // isSubColumn: isSubColumn,
                        // subColumns: subColumns,
                        isApproval: isApproval,
                        isRead: isRead
                    };
                });
            },
            formRows1 () {
                // console.log(this.formData[this.subform.id]);
                // console.log(this.subform.options.defaultSetting);
                if (this.formData[this.subform.id]) {
                    return this.formData[this.subform.id];
                } else {
                    return [];
                }
                // else if (!isEmpty(this.subform.options.defaultSetting) && this.subform.options.defaultSetting !== '') {
                //     console.log(this.subform.options.defaultSetting);
                //     let defaultValues = JSON.parse(this.subform.options.defaultSetting);
                //     this.formData[this.subform.id] = defaultValues;
                //     console.log(this.formData);
                //     return this.formData[this.subform.id];
                //     // return [];
                // }
            },
            formField () {
                // console.log(this.formData[this.subform.id]);
                return this.formData[this.subform.id];
            }
        },
        watch: {
            'approvalStatus' (newVal, oldVal) {
                if (newVal === 2) {
                    let ext2 = this.subform.options.ext2;
                    if (ext2) { // 审批后不允许修改了
                        let ext2Obj = JSON.parse(ext2);
                        if (ext2Obj.approveDisEditFieldAuth && ext2Obj.approveDisEditFieldAuth === '1') {
                            this.isRead = true;
                            this.subformIsReadTmp = true;
                        }
                    }
                }
            }
        },
        created () {
            // this.formData[this.subform.id] = [];
            this.subformIsReadTmp = this.subformIsRead;
            this.isShow = true;
            if (this.subform.options.ext2) {
                let ext2Obj = JSON.parse(this.subform.options.ext2);
                if (ext2Obj.synchronousApprovalComments === true) {
                    this.synchronousApprovalCommentsState = true;
                } else {
                    this.synchronousApprovalCommentsState = false;
                }
            }
        },
        methods: {
            initDefaultSetting (vals) {
                // this.formData[this.subform.id] = vals;
                // console.log(vals);
                if (!Array.isArray(this.formData[this.subform.id])) {
                    this.formData[this.subform.id] = [];
                }
                if (!isEmpty(vals)) {
                    let initArr = [];
                    vals.forEach(ele => {
                        initArr.push(ele);
                    });
                    this.formData[this.subform.id] = cloneDeep(initArr);
                }
            },
            cleanLabel (fieldList) {

            },
            async initAddLinkData (data) {
                // console.log(this.fieldList);
                // console.log(this.columnNames);
                let sourceFieldsMap = new Map();
                if (data && data.length > 0) {
                    // console.log(data[0]);
                    let fieldsArr = [];
                    for (var key in data[0]) {
                        // console.log(key);
                        if (key.indexOf('-') === -1) {
                            fieldsArr.push(key);
                        }
                    }
                    if (fieldsArr.length > 0) {
                        let sourceFields = await getFormFieldListByIds(fieldsArr.join(','));
                        // console.log(sourceFields);
                        for (let field of sourceFields) {
                            sourceFieldsMap.set(field.name + field.type, field);
                        }
                        // console.log(sourceFieldsMap);
                    }
                    for (let row of data) {
                        let tmp = {};
                        // console.log(row);
                        this.columnNames.forEach(ele => {
                            if (sourceFieldsMap.has(ele.label + ele.type)) {
                                let matchField = sourceFieldsMap.get(ele.label + ele.type);
                                // console.log(matchField);
                                if (matchField.type === 'user') {
                                    tmp[ele.id] = row[matchField.id];
                                    tmp[ele.id + '-user'] = row[matchField.id + '-user'];
                                } else if (matchField.type === 'select' || matchField.type === 'category') {
                                    // console.log(ele.options.config.options);
                                    let tempObj = ele.options.config.options.find(item => { // 暂时只支持单选
                                        return item.title === row[matchField.id + '-view'];
                                    });
                                    // console.log(tempObj);
                                    if (tempObj) {
                                        tmp[ele.id] = tempObj.value;
                                        tmp[ele.id + '-view'] = row[matchField.id + '-view'];
                                    }
                                } else {
                                    tmp[ele.id] = row[matchField.id];
                                }
                            } else {
                                tmp[ele.id] = '';
                            }
                        });
                        if (!Array.isArray(this.formData[this.subform.id])) {
                            this.formData[this.subform.id] = [];
                        }
                        // console.log(tmp);
                        this.formData[this.subform.id].push(tmp);
                    }
                }
            },
            handleAddRow () {
                let tmp = {};
                this.columnNames.forEach(ele => {
                    tmp[ele.id] = '';
                });
                if (!Array.isArray(this.formData[this.subform.id])) {
                    this.formData[this.subform.id] = [];
                }
                tmp.key = this.generateUUID();
    
                let ext2 = this.subform.options.ext2;
                if (ext2) {
                    let ext2Obj = JSON.parse(ext2);
                    if (ext2Obj.isLimitNumData) {
                        let limitNums = ext2Obj.limitNums;
                        if (this.formData[this.subform.id].length < limitNums) {
                            this.formData[this.subform.id].push(tmp);
                        } else {
                            this.$message.error('超出子表单配置限制');
                        }
                    } else {
                        this.formData[this.subform.id].push(tmp);
                    }
                } else {
                    this.formData[this.subform.id].push(tmp);
                }
                if (!isEmpty(this.taskInstance)) {
                    this.$emit('refreshViewField');
                }
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            handleDeleteItem (index, rows) {
                // rows.splice(index, 1);
                this.formRows1.splice(index, 1);
                // console.log(rows);
                // console.log(this.formRows1);
                this.loadTimerField = new Date().getTime();
                if (Array.isArray(this.formData[this.subform.id]) && isEmpty(this.formData[this.subform.id])) {
                    this.formData[this.subform.id] = '';
                }
            },
            isReadOnly (o, curValue) {
                if (this.subform.options.ext2) {
                    let ext2Obj = JSON.parse(this.subform.options.ext2);
                    if (ext2Obj.synchronousApprovalComments === true) {
                        return true;
                    } else {
                        if (curValue && curValue.key) {
                            return false;
                        } else {
                            if (o.options.ext2) {
                                let obj = JSON.parse(o.options.ext2);
                                if (obj.fieldReadOnly === undefined) { // 没有设置过允许填写
                                    return false;
                                } else {
                                    if (obj.fieldReadOnly === true) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }
                            } else {
                                return false;
                            }
                        }
                    }
                } else {
                    if (curValue && curValue.key) {
                        return false;
                    } else {
                        if (o.options.ext2) {
                            let obj = JSON.parse(o.options.ext2);
                            if (obj.fieldReadOnly === undefined) { // 没有设置过允许填写
                                return false;
                            } else {
                                if (obj.fieldReadOnly === true) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        } else {
                            return false;
                        }
                    }
                }
            },
            autoUserComplateData (key, value) {
                this.loadTimerField = new Date().getTime();
            },
            setColumnWidth (column) {
                if (column.type === 'date' && column.options.config.type === 'daterange') {
                    return '360px';
                } else if (column.type === 'file') {
                    return '350px';
                }
            },
            subFormCellClick (row) {
                // console.log(row);
            }
        }
    };
</script>


<style lang="less">
    .subform-field-item {
        display: flex;
        flex-direction: column;

        .subform-field {
            display: flex;
        }
        .el-form-item{
          .el-form-item--small{
            margin-bottom: 0px;
          }
        }
        .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
          margin-bottom: 1px;
          width:100%;
        }

        .el-table--small td, .el-table--small th {
            padding: 3px 0px 0px 0px;
        }
        .render-form-item {
            .el-form-item--small .el-form-item__content {
              width: 100%;
            }
            .item-textarea {
              // border: 1px solid red;
              width: 100%;
              .el-form-item__content {
                  width: 100%;
              }
              .el-input {
                  width: 100%;
              }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/FieldItem/FieldSubform.vue